import { useQuery } from "react-query";
import { gql } from "graphql-request";
import { usePbm2Url } from "@common/hooks";
import { IRegistrationPolicy } from "@pbm/registration-policies/contracts";

export function useRegistrationPolicy(id: string) {
  const { request } = usePbm2Url();
  return useQuery("registrationPolicy:" + id, async () => {
    const { Rules_registrationPolicy } = await request(
      gql`
        query registrationPolicy($id: ID!) {
          Rules_registrationPolicy(id: $id) {
            id
            createdAt
            updatedAt
            deletedAt
            requiresRegistration
            requiresPrescription
            requiresContactInformation
            enabledApiExternal
            description
            allowedOrigins
            formFields {
              code
              label
              type
              description
              display
              defaultValue
              entityField
              options {
                text
                value
              }
              externalApiField
            }
          }
        }
      `,
      { id }
    );
    if (Rules_registrationPolicy) {
      return Rules_registrationPolicy as IRegistrationPolicy;
    }
  });
}
